import { PRODUCT_BROADBAND } from '@/constants/products';
import { getProviders } from '@/graphql/queries/shared/institution';
import lang from '@/lang/middleware/products/broadband';

export default async ({ $apolloQuery, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  await $apolloQuery(getProviders, { product: PRODUCT_BROADBAND }).then(providers => {
    const description = store.$i18n.t('providers.description');
    const subtitle = store.$i18n.t('providers.jumbotron.subtitle');
    const title = store.$i18n.t('providers.title');
    store.commit('jumbotron/SET_JUMBOTRON', { subtitle, title, type: 'generic' });
    store.commit('pageContent/setHead', { description, title });
    store.commit('providers/setList', providers);
  });
};
